/**
 * Helpers for dealing with `document.cookie`.
 * @module cookies
 */

/** Returns the full cookie string with all cookies and values. */
export const getAllCookieString = () => {
  const allCookies = document.cookie;
  return typeof allCookies === 'string' ? allCookies : '';
};

/** Returns an object with cookie names and values as strings. */
export const parseCookies = (allCookieString) => {
  return allCookieString
    .split(';')
    .map((str) => str.trim())
    .map((keyAndValue) => {
      const afterSplit = keyAndValue.split('=').map((str) => str.trim());

      if (afterSplit.length === 2) {
        return { [afterSplit[0]]: afterSplit[1] };
      }

      return {};
    }).reduce((accumulatorObject, oneCookieObject) => ({
      ...accumulatorObject,
      ...oneCookieObject,
    }), {});
};

/** Returns string value of cookie with given name (case-insensitive), or the empty string if no
 * cookie exists with that name. */
export const getCookieValue = (allCookiesObject, cookieName) => {
  const matchingKey = Object.keys(allCookiesObject).filter(
    (key) => key.toLowerCase() === cookieName.trim().toLowerCase()
  );

  const cookieValue = allCookiesObject[matchingKey[0]];
  return typeof cookieValue === 'string' ? cookieValue : '';
};
